import {Component} from '@angular/core';
import {NavigationEnd, Router, RouterModule} from "@angular/router";
import {HeaderComponent} from "../header/header.component";
import {FooterComponent} from "../footer/footer.component";
import {filter, map, Observable, switchMap} from "rxjs";
import {AsyncPipe} from "@angular/common";

@Component({
    selector: 'app-root',
    imports: [RouterModule, HeaderComponent, FooterComponent, AsyncPipe],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    minWidth: Observable<string | null>

    constructor(private router: Router) {
        this.minWidth = this.router.events
            .pipe(
                filter(e => e instanceof NavigationEnd),
                map(() => this.router.routerState.root.firstChild),
                filter(route => route != null),
                switchMap(route => route!.data),
                map(data => data['minWidth'])
            )
    }
}
